import { registerQuery } from 'data-fetching-client';
import { fetchAllCategories, fetchCategory } from '../api/skillCategories.api';
export const fetchAllCategoriesQuery = registerQuery({
  fieldName: 'allCategories',
  fetcher: fetchAllCategories
});
export const fetchCategoryQuery = registerQuery({
  fieldName: 'category',
  fetcher: fetchCategory,
  args: ['category']
});